export default "__VITE_ASSET__DCasY6qa__"